import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http"
import { TranslateLoader, TranslateModule } from "@ngx-translate/core"
import { LayoutModule } from ".//layouts/layout.module"
import { AppRoutingModule } from "./app-routing.module"
import { AppComponent } from "./app.component"
import { MaskedService } from "src/app/core/services/masked.service"
import { TagService } from "./cadastro/admin/services/tag.service"
import { SchoolService } from "./cadastro/admin/services/school.service"
import { TenantService } from "./cadastro/admin/services/tenant.service"
import { TenantBrandService } from "./cadastro/admin/services/tenantBrand.service"
import { ProfileService } from "./cadastro/admin/services/profile.service"
import { FocusFirstInvalidFieldDirective } from "./shared/directive/focus-first-fInvalid-field.directive"
import { GoogleAnalyticsService } from "./core/services/google-analytics-events-service"
import { BrandService } from "./cadastro/admin/services/brand.service"
import { ProductService } from "./cadastro/admin/services/product.service"
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common"
import localePt from "@angular/common/locales/pt-PT"
import { AuthGuardService } from "./cadastro/admin/services/auth-guard.service"
import { ModificationGuardService } from "./cadastro/admin/services/modification-guard.service"
import { DashboardComponent } from "./cadastro/admin/components/dashboard/dashboard.component"
import { DashboardService } from "./cadastro/admin/services/dashboard.service"
import { TokenInterceptor } from "./core/interceptors/token.interceptor"
import { PermissionService } from "./cadastro/admin/services/permission.service"
import { GroupService } from "./cadastro/admin/services/group.service"
import { ClassService } from "./cadastro/admin/services/class.service"
import { FeatureFlagsService } from "./cadastro/admin/services/featureflags.service"
import { SegmentService } from "./cadastro/admin/services/segment.service"
import { GradeService } from "./cadastro/admin/services/grade.service"
import { SchooladminDashboardComponent } from "./cadastro/admin/components/schooladmin-dashboard/schooladmin-dashboard.component"
import { UnauthorizedAccessInterceptor } from "./core/interceptors/unauthorized-access.interceptor"
import { SsoService } from "./cadastro/admin/services/sso.service"
import { ImgDefaultDirective } from "./shared/directive/img-default.directive"
import { UserService } from "./cadastro/admin/services/user.service"
import { TenantModulesService } from "./cadastro/admin/services/tenant-modules.service"
import { HelpDeskService } from "./core/services/help-desk.service"
import { GoogleIntegrationService } from "./cadastro/admin/services/google-integration.service"
import { SharedComponentsModule } from "./shared/shared-components/shared-components.module"
import { MaskedDirective } from "./shared/directive/masked.directive"
import { SubjectsService } from "./cadastro/admin/services/subjects.service"
import { GRAYLOG_URI } from "./cadastro/admin/services/graylog/const/graylogConstants"
import { NgxMaskModule } from "ngx-mask"
import { ToastrModule } from "ngx-toastr"
import { ErrorHandler, NgModule } from "@angular/core"
import { FormsModule, ReactiveFormsModule } from "@angular/forms"
import { BrowserModule } from "@angular/platform-browser"
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog"
import { NgSelectModule } from "@ng-select/ng-select"

import { BrowserAnimationsModule } from "@angular/platform-browser/animations"
import { LexTranslateLoader } from "i18n/loader"
import { NgbModule } from "@ng-bootstrap/ng-bootstrap"
import { GlobalHttpErrorHandlerInterceptor } from "./core/interceptors/global-http-error-handler.interceptor"
import { OnboardingService } from "./cadastro/admin/services/onboarding.service"
import { MatSelectModule } from "@angular/material/select"
import { MatInputModule } from "@angular/material/input"
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper"
import { GenericDialogComponent } from "./shared/components/generic-dialog/generic-dialog.component"
import { MatIconModule } from "@angular/material/icon"
import { MatButtonModule } from "@angular/material/button"
import { MatFormFieldModule } from "@angular/material/form-field"
import { SuccessDialogComponent } from "./shared/components/success-dialog/success-dialog.component"
import { MatTableModule } from "@angular/material/table"
import { InformationDialogComponent } from "./shared/components/information-dialog/information-dialog.component"
import { AccessCardProfileDialogComponent } from "./shared/access-card-profile-dialog/access-card-profile-dialog.component"
import { environment } from "src/environments/environment"
import { ObservabilityErrorHandler } from "./core/observability/observability-error.handler"
import { ObservabilityHttpInterceptor } from "./core/observability/observability-http.interceptor"

registerLocaleData(localePt, "pt")

@NgModule({
  declarations: [
    AppComponent,
    FocusFirstInvalidFieldDirective,
    DashboardComponent,
    SchooladminDashboardComponent,
    GenericDialogComponent,
    SuccessDialogComponent,
    InformationDialogComponent,
    SuccessDialogComponent,
    AccessCardProfileDialogComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    NgSelectModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: "toast-top-center",
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true,
    }),
    AppRoutingModule,
    LayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    SharedComponentsModule,
    MatDialogModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: LexTranslateLoader,
        deps: [HttpClient],
      },
    }),
    NgbModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
  ],
  exports: [MaskedDirective, FocusFirstInvalidFieldDirective],
  entryComponents: [],
  providers: [
    FeatureFlagsService,
    TagService,
    SchoolService,
    TenantService,
    TenantBrandService,
    GroupService,
    ClassService,
    SegmentService,
    GradeService,
    PermissionService,
    ProfileService,
    BrandService,
    ProductService,
    AuthGuardService,
    ModificationGuardService,
    DashboardService,
    DatePipe,
    SsoService,
    MaskedService,
    GoogleAnalyticsService,
    OnboardingService,
    HelpDeskService,
    UserService,
    SubjectsService,
    TenantModulesService,
    GoogleIntegrationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UnauthorizedAccessInterceptor,
      multi: true,
    },
    {
      provide: GRAYLOG_URI,
      useValue: "https://graylog.conexia.com.br/gelf",
    },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalHttpErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ObservabilityHttpInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: ObservabilityErrorHandler,
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
